import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-topographic-code-assignment-form/configuration-automation-personnel-entities-association-modal-topographic-code-assignment-form.model'
import {
    ConfigurationPersonnelTopographicCodeAssignmentCreateRequest,
    ConfigurationPersonnelTopographicCodeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-topographic-code-assignment/configuration-personnel-topographic-code-assignment.dto'
import { commonTopographicCodeService } from '@/api/services/common/topographic-code/common-topographic-code.service'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { configurationPersonnelTopographicCodeAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-topographic-code-assignment/configuration-personnel-topographic-code-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentFormState()
    }

    private async _loadTopographicCodes(): Promise<void> {
        this.state.topographicCodes = await this._getTopographicCodes()
    }

    private async _loadPersonnelTopographicCodeAssignments(): Promise<void> {
        this.state.personnelTopographicCodeAssignments = await this._getPersonnelTopographicCodeAssignments()
    }

    async mounted() {
        await this._loadTopographicCodes()
        await this._loadPersonnelTopographicCodeAssignments()
    }

    /// SERVICES CALLS ///

    private async _getTopographicCodes(): Promise<CommonTopographicCodeResponse[]> {
        const response = await this.$_toCallUnique(commonTopographicCodeService.getTopographicCodes())
        if (response) {
            return response
        }
        return []
    }

    private async _getPersonnelTopographicCodeAssignments(): Promise<ConfigurationPersonnelTopographicCodeAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelTopographicCodeAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelTopographicCodeAssignment(createRequest: ConfigurationPersonnelTopographicCodeAssignmentCreateRequest): Promise<ConfigurationPersonnelTopographicCodeAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelTopographicCodeAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deletePersonnelTopographicCodeAssignment(personnelTopographicCodeAssignmentId: number): Promise<void> {
        if (personnelTopographicCodeAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelTopographicCodeAssignmentService.delete(personnelTopographicCodeAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(topographicCode: CommonTopographicCodeResponse): Promise<void> {
        if (topographicCode) {
            const createRequest: ConfigurationPersonnelTopographicCodeAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                topographicCodeId: topographicCode.id
            }
            if (await this._createPersonnelTopographicCodeAssignment(createRequest)) {
                await this._loadPersonnelTopographicCodeAssignments()
            }
        }
    }

    async deleteOperation(personnelTopographicCodeAssignment: ConfigurationPersonnelTopographicCodeAssignmentResponse): Promise<void> {
        if (personnelTopographicCodeAssignment) {
            await this._deletePersonnelTopographicCodeAssignment(personnelTopographicCodeAssignment.id)
            await this._loadPersonnelTopographicCodeAssignments()
        }
    }
}
